window.info = window.dev = window.devs = window.developer = window.developers = window.credit = window.team = window.about = () => {
    console.log("\nMahmoud Faisal: Full-Stack Web Developer\nLinkedIn: https://www.linkedin.com/in/mahmoud-faisal/\n\n");

    console.log("\nAbdelrahman Awad: Front-End Web Developer\nLinkedIn: https://www.linkedin.com/in/abdelrahman-awad-in/\n\n");

    console.log("\nAhmed Osama: Front-End Web Developer\nLinkedIn: https://www.linkedin.com/in/ahmed-osama-7020391b7/\n\n");

    console.log("\nMarco Emad: UI/UX Designer\nLinkedIn: https://www.linkedin.com/in/marco-emad-studios-86a975212/\n\n");
}
